import React, {useCallback} from 'react';
import {Button} from 'react-bootstrap';
import Icon from 'shared/Icon';
import styled from 'styled-components';

const ViewRoomPlanner = ({link3DRP}: {link3DRP: string}) => {
    const onOpen3DRP = useCallback(() => {
        if (link3DRP) {
            window.open(link3DRP, '_blank');
        }
    }, [link3DRP]);

    return (
        <ButtonContainer>
            <Button className="button-blue" type="button" onClick={onOpen3DRP}>
                <IconContainer>
                    <Icon iconName="RoomPlanner.svg" color="secondary" />
                </IconContainer>
                View in 3D Room Planner
            </Button>
        </ButtonContainer>
    );
};

const ButtonContainer = styled.div`
    position: absolute;
    z-index: 9999;
    bottom: 30px;
    left: 30px;
    & > button {
        width: fit-content;
        font-size: 0.9rem;
        font-weight: normal;
        width: 170px;
        height: 55px;
        text-align: left;
        line-height: 1.1;
        padding: 4px;
        border: 0;
    }
    @media screen and (max-width: 768px) and (orientation: portrait) {
        bottom: 120px;
        right: 15px;
        top: unset;
        left: unset;
    }
`;

const IconContainer = styled.div`
    width: 45px;
    height: 45px;
    background: white;
    border-radius: 50%;
    padding: 7.5px;
    margin-right: 6px;
    & > img {
        height: 30px;
        width: 30px;
    }
`;

export default ViewRoomPlanner;
